import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  setLoadingOverviewConversionsMobileData,
  setOverviewConversionsMobileData,
} from "../../../../../../../../../../../features/bizDevelopmentDashboardMobileSlice";
import { setDisplayErrorSnackBar } from "../../../../../../../../../../../features/userSlice";
import { bizDevelopmentDashboardMobileService } from "../../../../../../../../../../../services/mobileAPI/biz-dev-dashboard.endpoints";

interface UseOverviewConversionsMobileProps {
  params?: any;
  autoFetch?: boolean;
}

export const useOverviewConversionsMobile = ({
  params,
  autoFetch = true,
}: UseOverviewConversionsMobileProps) => {
  const dispatch = useDispatch();
  const fetchOverviewConversions = useCallback(
    async (overrideParams?: any) => {
      dispatch(setLoadingOverviewConversionsMobileData(true));
      try {
        const response =
          await bizDevelopmentDashboardMobileService.getOverviewConversionsMobileData(
            overrideParams || params,
          );
        if (!response?.status || response.status !== 200) {
          throw new Error("API failed");
        }
        dispatch(setOverviewConversionsMobileData(response.data?.data || []));
      } catch (e: any) {
        dispatch(
          setDisplayErrorSnackBar({
            message:
              e?.parsedText ||
              "Failed to fetch Overview Conversions data. Please try again later.",
            type: "error",
          }),
        );
      } finally {
        dispatch(setLoadingOverviewConversionsMobileData(false));
      }
    },
    [params, dispatch],
  );

  useEffect(() => {
    if (autoFetch && params) {
      fetchOverviewConversions();
    }
  }, [params, autoFetch, fetchOverviewConversions]);

  return { fetchOverviewConversions };
};
